import { ErrorsSummaryProps } from "./types";
import * as Styled from "./styles";

const ErrorsSummary: React.FC<ErrorsSummaryProps> = ({ errors }) =>
  errors?.length ? (
    <Styled.ErrorSummaryList>
      {errors.map((error) => (
        <Styled.ErrorSummaryListItem key={error}>
          {error}
        </Styled.ErrorSummaryListItem>
      ))}
    </Styled.ErrorSummaryList>
  ) : null;

export default ErrorsSummary;
